import { Navbar } from "@/components/wedding/Navbar";
import { Hero } from "@/components/wedding/Hero";
import { OurStory } from "@/components/wedding/OurStory";
import { Program } from "@/components/wedding/Program";
import { Location } from "@/components/wedding/Location";
import { Gallery } from "@/components/wedding/Gallery";
import { Gaveliste } from "@/components/wedding/Gaveliste";
import { Accommodation } from "@/components/wedding/Accommodation";
import { Rsvp } from "@/components/wedding/Rsvp";
import { Footer } from "@/components/wedding/Footer";

export default function Wedding() {
  return (
    <main data-testid="wedding-page" className="bg-[#F3F5E7] text-[#3D5E68]">
      <Navbar />
      <Hero />
      <OurStory />
      <Program />
      <Location />
      <Gallery />
      <Gaveliste />
      <Rsvp />
      <Accommodation />
      <Footer />
    </main>
  );
}
